export default "__VITE_ASSET__BSTRITbj__"